import { useState } from 'react'
import { CheckCircleIcon } from '@heroicons/react/solid'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import IsAuth from '../../utillityComponents/IsAuth'

// Bank transfers and invoices are not validated against a payment provider,
// so they count as unpaid until an Admin or Ngo confirms the money arrived.
export const MANUALLY_CONFIRMED_TYPES = ['transfer', 'invoice']

const badge = 'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium'

export default function PaymentConfirmation({ sponsor, onChange, showUndo = false }) {
    const axiosPrivat = useAxiosPrivate()
    const canConfirm = IsAuth(['Admin', 'Ngo'])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    const send = async (method) => {
        setLoading(true)
        setError(null)
        try {
            const res = await axiosPrivat[method](`/sponsor/${sponsor.id}/confirm-payment`)
            onChange && onChange(res.data)
        } catch (err) {
            console.error(err)
            setError(err?.response?.data?.message || 'Kunne ikke gemme')
        }
        setLoading(false)
    }

    if (!MANUALLY_CONFIRMED_TYPES.includes(sponsor.payment_type)) {
        return sponsor.has_paied
            ? <span className={badge + ' bg-green-100 text-green-800'}>Ja</span>
            : <span className={badge + ' bg-red-100 text-red-800'}>Nej</span>
    }

    if (sponsor.payment_confirmed_at) {
        return (
            <span className="inline-flex items-center gap-2">
                <span
                    className={badge + ' bg-green-600 text-white'}
                    title={'Bekræftet ' + new Date(sponsor.payment_confirmed_at).toLocaleString('da-DK')}
                >
                    <CheckCircleIcon className="h-4 w-4 mr-1" aria-hidden="true" />
                    Bekræftet betalt
                </span>
                {showUndo && canConfirm && (
                    <button
                        type="button"
                        disabled={loading}
                        onClick={() => send('delete')}
                        className="text-xs text-gray-500 hover:text-gray-700 disabled:opacity-50"
                    >
                        Fortryd
                    </button>
                )}
                {error && <span className="text-xs text-red-600">{error}</span>}
            </span>
        )
    }

    return (
        <span className="inline-flex items-center gap-2">
            <span className={badge + ' bg-red-100 text-red-800'} title="Betalingen er ikke bekræftet modtaget">
                Nej
            </span>
            {canConfirm && (
                <button
                    type="button"
                    disabled={loading}
                    onClick={() => send('post')}
                    className="text-xs font-medium text-indigo-600 hover:text-indigo-800 disabled:opacity-50"
                >
                    {loading ? 'Gemmer…' : 'Bekræft betalt'}
                </button>
            )}
            {error && <span className="text-xs text-red-600">{error}</span>}
        </span>
    )
}
